import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="map-drawer"
export default class extends Controller {
  connect() {
    this.setIsShown();
  }

  get isMobile() {
    return window.innerWidth < 768;
  }

  setIsShown() {
    // Disable the backdrop to allow map interaction while the drawer is open on desktop.
    // On mobile, map interaction is disabled and the drawer is not shown by default.
    if (!this.isMobile) {
      this.toggle.checked = true;
    }
  }

  hide() {
    // drawer cannot be hidden on desktop
    if (this.isMobile) {
      this.toggle.checked = false;
    }
  }

  get toggle() {
    return this.element.querySelector(".drawer-toggle")
  }
}